<template>
  <v-content class="gb">
    <v-container class="fill-width" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="11" class>
          <v-card :loading="status === 'loading'"
                  class="fill-width card-theme mt-5 card-content custom-p-vendor-signup signup-form-container">
            <v-row class="flex-colum" align="center" style="padding-top: 12px;">
              <v-col lg4 xs12 class="pl-5">
                <h2 class="title_aggent" style="margin-top: 0.75rem; margin-bottom: 1.12rem">
                  Sign
                  Up
                </h2>
              </v-col>
              <v-col lg8 xs12>
                <p class="tex_edition">
                  Already have an account?
                  <router-link to="/" class="login-class no-decoration ml-3">Login</router-link>
                </p>
              </v-col>
            </v-row>
            <v-divider
                class="mt-7 divider-margin align-divider signup-divider"
                style="max-width: 970px !important;"
            ></v-divider>
            <v-alert
                dense
                text
                type="error"
                v-if="invalid_link"
                class="invalid-link__agent"
            >Invalid link
            </v-alert>
            <v-alert :value="true" color="#19A99D" class="alert-login-vendor custom_alert">
              <strong>
                <h3 class="mb-3">Congratulations!!</h3>
              </strong>
              <p style="display: inline-block;">
                You have been invited to participate as a user of the KIEY
                application by:
              </p>
              <p style>
                <strong style="font-size: 22px;">{{ company_name }}</strong>
              </p>
              <p>Please ensure the cell phone number listed below is correct
                before activating your account.</p>
              <p v-if="nameOwner">
                If this is not your correct cell phone number, please notify
                <span style="text-transform: capitalize;">{{ nameOwner }}</span> for correction.
              </p>
            </v-alert>
            <v-divider class="mt-2 mb-10 align-divider signup-divider" style="max-width: 970px !important;"></v-divider>

            <v-form
                class="padd-log-step"
                style="max-width: 1004px !important; margin-left: 4px !important;"
            >
              <ValidationObserver ref="validator" v-slot="{}">
                <div>
                  <v-row align="center">
                    <v-col cols="12" sm="4" class="px-5">
                      <keep-alive>
                        <ValidationProvider ref="first_name" rules="required"
                                            v-slot="{ errors }">
                          <v-text-field
                              v-model="first_name"
                              :error-messages="errors"
                              class="ui-label change_bord especial_border support-input custom-input-position-text sing_up"
                              label="First Name"
                              name="firstName"
                              type="text"
                              width="660px"
                          ></v-text-field>
                        </ValidationProvider>
                      </keep-alive>
                    </v-col>
                    <v-col cols="12" sm="4" class="px-5">
                      <keep-alive>
                        <ValidationProvider ref="last_name" rules="required"
                                            v-slot="{ errors }">
                          <v-text-field
                              v-model="last_name"
                              :error-messages="errors"
                              class="ui-label change_bord especial_border support-input custom-input-position-text sing_up"
                              label="Last Name"
                              name="lastName"
                              type="text"
                              width="660px"
                          ></v-text-field>
                        </ValidationProvider>
                      </keep-alive>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="px-5">
                      <keep-alive>
                        <ValidationProvider
                            ref="phone_number"
                            rules="required|size:10"
                            v-slot="{ errors }"
                            mode="lazy"
                        >
                          <v-text-field
                              ref="phone"
                              v-model="phone_number"
                              :error-messages="errors"
                              v-mask="mask"
                              class="ui-label change_bord especial_border support-input custom-input-position-text sing_up fwi-18"
                              label="Username (Cell Phone Number)"
                              name="phone_number"
                              type="tel"
                              inputmode="tel"
                              width="660px"
                              placeholder="xxx - xxx - xxxx"
                          ></v-text-field>
                        </ValidationProvider>
                      </keep-alive>
                    </v-col>
                  </v-row>
                  <v-row align="center">
                    <v-col cols="12" sm="6" md="4" class="px-5">
                      <keep-alive>
                        <ValidationProvider ref="email" rules="required|email" v-slot="{ errors }">
                          <v-text-field
                              v-model="email"
                              :error-messages="errors"
                              class="ui-label change_bord especial_border support-input custom-input-position-text sing_up"
                              label="Email"
                              name="email"
                              type="email"
                              inputmode="email"
                              width="660px"
                          ></v-text-field>
                        </ValidationProvider>
                      </keep-alive>
                    </v-col>
                  </v-row>
                </div>
                <consent-checkboxes
                    :sms-consent.sync="sms_consent"
                    :email-consent.sync="email_consent"
                />
              </ValidationObserver>
            </v-form>
            <v-card-text class>
              <div class="p-4">
                <div class="text-center pt-8 mt-8">
                  <v-btn rounded class="btn-azul btn_sing_agent" @click="submit">Activate</v-btn>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <congratulations-modal :show="showCongratulationsModal" :hide="hideModal"/>
  </v-content>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {mask} from "vue-the-mask";
import congratulationsModal from "./modals/congratulations";
import {mapState} from "vuex";
import config from "@/config/constants.js";
import ConsentCheckboxes from "@/components/forms/ConsentCheckboxes";

export default {
  name: "SignUpAgent",
  directives: {
    mask
  },
  computed: {
    ...mapState({
      status: (state) => state.Agent_sign_up.status,
      nameOwner: (state) => state.Agent_sign_up.name_owner,
      company_name: (state) => state.Agent_sign_up.company_name,
    }),
  },
  mounted() {
    this.getNameOwner();
  },
  created() {
    if (this.$store.getters['Authenticate/isLoggedIn']) {
      this.$store.dispatch("Authenticate/safety_logout");
      this.$store.dispatch("Banner/hide");
    }
  },
  data: () => ({
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    mask: "### - ### - ####",
    showCongratulationsModal: false,
    invalid_link: false,
    sms_consent: false,
    email_consent: false,
  }),
  components: {
    ValidationProvider,
    ValidationObserver,
    "congratulations-modal": congratulationsModal,
    ConsentCheckboxes,
  },
  methods: {
    getNameOwner() {
      const self = this;
      let token = self.$route.params.referral ? self.$route.params.referral : self.$route.query.referral;
      if (token) {
        self.$store
            .dispatch("Agent_sign_up/add_name_owner", token)
            .then(function (response) {
              if (response['data']['code'] && response['data']['code'] === "ERROR") {
                self.invalid_link = true;
              } else {
                self.first_name = response.data.user['first_name'];
                self.last_name = response.data.user['last_name'];
                self.phone_number = response.data.user['phone_number'].replace(config.phone_extension, "");
                if (response.data.user['email']) {
                  self.email = response.data.user['email'];
                }
                self.$refs.phone.focus();
                self.$refs.phone.blur();
              }
            })
            .catch(function (errors) {
              console.error(errors);
            });
      }
    },
    async submit() {
      const self = this;
      const valid = await this.$refs.validator.validate();
      if (!valid) return;
      if (!self.sms_consent || !self.email_consent) return;

        let phone = self.phone_number;
        phone = phone.replaceAll(' ', '').replaceAll('-', '');
        phone = config.phone_extension + phone;

        self.$store
            .dispatch("Agent_sign_up/signup_agent", {
              'first_name': self.first_name,
              'last_name': self.last_name,
              'phone_number': phone,
              'email': self.email,
              'sms_consent': self.sms_consent,
              'email_consent': self.email_consent,
              'sms_consent_url': window.location.href
            })
            .then(function () {
              self.showCongratulationsModal = true;
            })
            .catch(function (error) {
              self.$refs.phone_number.setErrors([error]);
            });
    },
    hideModal() {
      this.showCongratulationsModal = false;
    },
  },
};
</script>

<style scoped>
.btn_sing_agent {
  font-size: 15px !important;
}

.custom_alert {
  margin: 9px 0 0 26px !important;
  padding: 21px 0 2px 27px;
  border-radius: 16px !important;
}

.tex_edition {
  margin-bottom: 8px;
  padding-left: 230px;
}

.summary-label {
  color: #061d47;
  border-radius: 1rem;
}

.summary-value {
  color: #3c5fa9;
}

.alert-login-vendor h3 {
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
}

.alert-login-vendor {
  margin: 0 auto;
  color: white !important;
  margin: 0 0.5rem 0 1rem;
  border-radius: 1rem;
  max-width: 970px !important;
  height: auto !important;
}

.alert-login-vendor p {
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.33px;
  line-height: 18px;
}

.title_aggent {
  color: #041332;
  font-size: 30px;
  font-weight: 500;
  line-height: 34px;
  font-family: "Roboto-Medium" !important;
}

.align-divider {
  margin-left: 26px !important;
}

@media (max-width: 1200px) {
  .alert-login-vendor {
    width: 100% !important;
    height: auto !important;
    margin: 0 auto !important;
    padding: 15px !important;
  }

  .tex_edition {
    padding-left: 0 !important;
  }

  .align-divider {
    margin-left: auto !important;
  }

  .custom-p-vendor-signup {
    padding: 15px !important;
  }
}
</style>
